import { Box, Checkbox, Typography, Grid } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { Fragment } from "react";
import { SchemeData } from ".";
import { CartItemSipNew } from "../../../../store/actions";
import Image from "../../../Image";
import { CartItemProps } from "../useInvestorCart";
import { convertToInr } from "../../../../utils/cart";

export const RedemptionCartItem: CartItemProps<"RED"> = function (props) {
  const {
    cartId,
    cartItemId,
    editCartItem,
    fundCode,
    isSelected,
    payload,
    removeCartItem,
    selectCartItem,
  } = props;

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            checked={isSelected}
            onChange={() => selectCartItem(cartItemId)}
            style={{ color: "#2057A6" }}
          />
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
            }}
          >
            {payload.schemeName}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            padding: "10px",
          }}
        >
          <Image
            src="/images/edit_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => editCartItem(cartId, cartItemId, fundCode)}
          />
          <Image
            src="/images/delete_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => removeCartItem(cartId, cartItemId)}
          />
        </Box>
      </Box>

      <Grid container style={{ padding: "12px", justifyContent: "flex-end" }}>
        <Grid item xs={12} lg={3}>
          <SchemeData
            name={Number(payload.amount) > 0 ? "Amount" : "Units"}
            value={
              Number(payload.amount) > 0
                ? convertToInr(payload.amount)
                : payload.units
            }
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export const RedemptionSummaryItem = ({ payload, ...rest }: CartItemSipNew) => {
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
            }}
          >
            {payload.schemeName}
          </Typography>
        </Box>
      </Box>

      <Grid container style={{ padding: "12px", justifyContent: "flex-end" }}>
        <Grid item xs={12} lg={3}>
          <SchemeData
            name={Number(payload.amount) > 0 ? "Amount" : "Units"}
            value={
              Number(payload.amount) > 0
                ? `${"\u20B9" + payload.amount}`
                : payload.units
            }
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};
